export const formatPrice = (value) => {
  if (!value && value !== 0) return 'N/A';
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numericValue)) return 'N/A';
  return '$' + numericValue.toLocaleString('en-US');
};

export const formatPriceWithSign = (value) => {
  if (!value && value !== 0) return 'N/A';
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numericValue)) return 'N/A';
  const sign = numericValue > 0 ? '+' : '';
  return `${sign}$${Math.abs(numericValue).toLocaleString('en-US')}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  } catch (e) {
    console.error('Date formatting error:', e);
    return 'N/A';
  }
};

export const formatPercentage = (percentage) => {
  if (!percentage && percentage !== 0) return 'N/A';
  const sign = percentage > 0 ? '+' : '';
  return `${sign}${percentage.toFixed(1)}%`;
};

export const formatQueueTime = (seconds) => {
  if (!seconds) return '0s';
  return `${Math.ceil(seconds)}s`;
};

export const formatMonthYear = (date) => {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};